import { Tooltip } from "@mui/material";
import TextField from "@mui/material/TextField";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

const CustomTextInput = ({ ...props }) => {
  const { size, type, value } = props;
  let variant = props.variant || "standard";
  //limit variant only contained, outlined, standard
  if (
    variant != "contained" &&
    variant != "outlined" &&
    variant != "filled" &&
    variant != "standard"
  ) {
    variant = "standard";
  }
  if (type == "label") {
    return <span className="hm-text">{value}</span>;
  }
  if (type == "number") {
    if (size === "small") {
      return (
        <TextField
          {...props}
          sx={{ width: "100px", paddingBottom: "0px" }}
          type="number"
          variant={variant}
          className={"hm-text " + props?.className}
        />
      );
    } else {
      return (
        <TextField
          {...props}
          fullWidth
          sx={{ width: "100px", paddingBottom: "0px" }}
          type="number"
          variant={variant}
          className={"hm-text " + props?.className}
        />
      );
    }
  } else {
    if (size === "small") {
      return (
        <div
          style={{
            position: "relative",
            width: "100px",
            paddingRight: props?.cavalue ? "20px" : undefined,
          }}
        >
          <TextField
            {...props}
            sx={{ width: "100px", paddingBottom: "0px" }}
            type="text"
            variant={variant}
            className={"hm-text " + props?.className}
          />
          {props?.cavalue && (
            <div
              style={{
                position: "absolute",
                top: "50%",
                right: "3px",
                transform: "translateY(-50%)",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Tooltip title={props?.cavalue} placement="right-end">
                <HelpOutlineIcon color="action" sx={{ fontSize: "14px" }} />
              </Tooltip>
            </div>
          )}
        </div>
      );
    } else {
      return (
        <TextField
          {...props}
          fullWidth
          sx={{ width: "100px", paddingBottom: "0px" }}
          type="text"
          variant={variant}
          className={"hm-text " + props?.className}
        />
      );
    }
  }
};

export default CustomTextInput;
